$(document).on('click', '.b-toggle-block__toggle-btn', function handler() {
  const $bToggleBlock = $(this).parents('.b-toggle-block') // .b-toggle-block
  const openState = $bToggleBlock.attr('data-is-open')

  if (openState === '0') {
    $bToggleBlock.attr('data-is-open', '1')
  } else if (openState === '1') {
    $bToggleBlock.attr('data-is-open', '0')

    if ($bToggleBlock.offset().top + 200 < $(window).scrollTop()) {
      $('html, body').stop().animate({ scrollTop: $bToggleBlock.offset().top - 200 }, 500, 'swing')
    }
  }
})
